import { View, ViewProps } from '@shared/components/View';
import styles from './MenuScrollable.module.css';

/**
 * Menu.Scrollable
 *
 * A scrollable wrapper for menu content. Pass `showScrollIndicators` to
 * display fade masks at the top and bottom when the list overflows.
 */

export interface MenuScrollableProps extends ViewProps {
  showScrollIndicators?: boolean;
}

export function MenuScrollable({
  children,
  className,
  showScrollIndicators = false,
  ...rest
}: MenuScrollableProps) {
  return (
    <View
      className={[
        styles.scrollable,
        showScrollIndicators && styles.showScrollIndicators,
        className,
      ]}
      {...rest}
    >
      {showScrollIndicators && <View className={[styles.scrollMask, styles.scrollMaskTop]} />}
      {children}
      {showScrollIndicators && <View className={[styles.scrollMask, styles.scrollMaskBottom]} />}
    </View>
  );
}
